// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1_5Pt{width:820px!important;width:82rem!important}", ""]);
// Exports
exports.locals = {
	"wrapper__box": "_1_5Pt"
};
module.exports = exports;
